const formControlLabelModalSupportFiles = {
  all: 'All',
  internal: 'Internal',
  external: 'Contracted'
};

export default formControlLabelModalSupportFiles;
